module.exports = __webpack_public_path__ + "img/icon-direita-baixo.5721f973.png";